import zh from './lang/zh.json'
import en from './lang/en.json'
import ja from './lang/jp.json'
import es from './lang/es.json'
import de from './lang/de.json'
import fr from './lang/fr.json'
import ru from './lang/ru.json'
import pt from './lang/pt.json'
import tr from './lang/tr.json'
import zh_Hant from './lang/zh_Hant.json'

export default defineI18nConfig(() => ({
  legacy: true,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { zh,en,ja,es,de,fr,ru,'zh-hant':zh_Hant,pt,tr }
}))
